import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header.jsx';           // ваш компонент шапки
import currentImg from '../images/Смородина_картинка.jpg'; // пример картинки
import '../style/CakeDetail.css';

const CakeDetailCurrent = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();

  return (
    <>
      <Header />

      <div className="detail-container">
        <div className="detail-text">
          <h2>Наполеон со смородиной</h2>
          <p>Мякоть плодов с ярко выраженным десертным вкусом и ароматом
                            придаст торту насыщенный вкус и необычайную сладость.</p>
          <p><strong>Вес:</strong> 1,4&nbsp;кг</p>
          <p><strong>Цена:</strong> 2300&nbsp;₽</p>
          <button onClick={() => navigate(-1)} className="back-button">
            ← Назад
          </button>
        </div>

        <div className="detail-image">
          <img src={currentImg} alt="Наполеон Классический" />
        </div>
      </div>
    </>
  );
};

export default CakeDetailCurrent;
